import { gql } from '@apollo/client';

export const getBusinessPartnerInfo = gql`
  query getBusinessPartnerInfo($id: String!) {
    SalesforceManagement {
      entities {
        businessPartner(id: $id) {
          id
          views {
            SalesforceManagement_all {
              properties {
                Type {
                  Code
                }
                PersonID {
                  id
                  views {
                    SalesforceManagement_all {
                      properties {
                        FullName
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const getGeneralLovs = gql`
  query {
    Accounting_PaymentMethodList: __type(name: "Accounting_PaymentMethodList") {
      name
      enumValues {
        name
      }
    }
  }
`;

export const getLovs = gql`
  query {
    PlanConfigManagement {
      queries {
        allLines {
          planConfigManagement_Line_Name
          planConfigManagement_Line_Id
        }
      }
    }
    Production_PaymentDivisionTypeList: __type(
      name: "Production_PaymentDivisionTypeList"
    ) {
      name
      enumValues {
        name
      }
    }
  }
`;

export const getPolicies = gql`
  query BrokerPoliciesListPaginated(
    $pagination: PaginationInput!
    $OrderByField: String
    $DescendingField: Boolean
    $SelectedLine: [String]
    $SelectedCurrency: [String]
    $PolicyIssuanceFrom: Date
    $PolicyIssuanceTo: Date
    $BusinessPartnerID: String
  ) {
    Accounting {
      queries {
        BrokerPoliciesListPaginated(
          pagination: $pagination
          SelectedLine: $SelectedLine
          SelectedCurrency: $SelectedCurrency
          PolicyIssuanceFrom: $PolicyIssuanceFrom
          PolicyIssuanceTo: $PolicyIssuanceTo
          BusinessPartnerID: $BusinessPartnerID
          OrderByField: $OrderByField
          DescendingField: $DescendingField
        ) {
          paging {
            pageSize
            pageNumber
            totalCount
          }
          items {
            parentBill_ParentBillCategory
            policy_PolicyNumber
            policy_CertificateNumber
            policy_Id
            policy_Type
            linkedAmendment_AmendmentNumber
            linkedAmendment_AmendmentLineNumber
            parentBill_Id
            payableBills_TotalPremium
            policy_PaymentDivisionType
            policy_TotalAmountReceived
            payableBills_TotalCommission
            payableBills_TaxOnCommission
            payableBills_AmountPaid
            payableBills_AmountReceived
            policy_PaymentMode {
              Title
            }
            policy_PolicyCurrency {
              Symbol
            }
          }
        }
      }
    }
  }
`;

export const getBreakdown = gql`
  query GetPolicyReceivableBills(
    $PolicyID: String!
    $BusinessPartnerID: String!
    $pagination: PaginationInput!
    $ParentBillID: String
  ) {
    Accounting {
      queries {
        GetPolicyReceivableBills(
          PolicyID: $PolicyID
          ParentBillID: $ParentBillID
        ) {
          parentBill_ParentBillCategory
          accounting_Bills_Id
          accounting_Bills_BillNumber
          accounting_Bills_IsVoided
          accounting_Bills_PolicyID {
            views {
              Production_all {
                properties {
                  PolicyNumber
                  CertificateNumber
                }
              }
            }
          }
          policy_Type
          accounting_Bills_DueDate
          accounting_Bills_NetPremium
          accounting_Bills_BillType
          accounting_Bills_AmountDue
          accounting_Bills_TotalPremium
          accounting_Bills_AmountReceived
          accounting_Bills_AmountPaid
          accounting_Bills_OutstandingBalance
          accounting_Bills_BillStatus
          linkedAmendment_AmendmentNumber
          linkedAmendment_AmendmentLineNumber
          accounting_Bills_Currency {
            Symbol
          }
        }
        GetBusinessPartnerBillOfPolicy(
          PolicyID: $PolicyID
          BusinessPartnerID: $BusinessPartnerID
          pagination: $pagination
          ParentBillID: $ParentBillID
        ) {
          items {
            linkedAmendment_AmendmentNumber
            linkedAmendment_AmendmentLineNumber
            policy_Type
            parentBill_ParentBillCategory
            accounting_Bills_BillNumber
            accounting_Bills_IsVoided
            accounting_Bills_PolicyID {
              views {
                Production_all {
                  properties {
                    PolicyNumber
                    CertificateNumber
                  }
                }
              }
            }
            accounting_Bills_DueDate
            accounting_Bills_Discount
            accounting_Bills_TaxOnCommission
            accounting_Bills_TotalCommission
            accounting_Bills_OutstandingBalance
            accounting_Bills_AmountPaid
            accounting_Bills_BillStatus
            accounting_Bills_Id
            accounting_Bills_BillType
            accounting_Bills_Currency {
              Symbol
            }
          }
          paging {
            pageSize
            pageNumber
            totalCount
          }
        }
      }
    }
  }
`;
